import i18next from 'i18next';

i18next.addResources('es_CL', 'Orders', {
  addBlock: 'Bloquear producto o modificador',
  autoAcceptOrder: 'Auto-aceptar pedidos',
  enabledManualDelivery: 'Delivery automático',
  manualDeliveryTooltip:
    'Al estar activo solicitaremos repartidores de forma automática cuando los pedidos pasan a preparación.',
  of: 'de',
  moreThan: 'mas que'
});

i18next.addResources('es_CR', 'Orders', {
  addBlock: 'Bloquear producto o modificador',
  autoAcceptOrder: 'Auto-aceptar pedidos',
  enabledManualDelivery: 'Delivery automático',
  manualDeliveryTooltip:
    'Al estar activo solicitaremos repartidores de forma automática cuando los pedidos pasan a preparación.',
  of: 'de',
  moreThan: 'mas que'
});
